import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './LegendItem.scss';
export const LegendItem = (props) => {
    return (_jsxs("li", { className: 'lgd-legendItem', children: [_jsx("figure", { className: 'lgd-legendItem--figure', children: _jsx("img", { src: props.imgSrc, alt: '', loading: 'lazy' }) }), _jsx("figcaption", { children: props.label })] }));
};
//# sourceMappingURL=LegendItem.js.map